/**
 * WebSocket event interfaces — mirror the payloads emitted by
 * aumico-ms-ai-agents' WebSocket gateway on the /ai-agents namespace.
 */

/** Emitted via `ai:job:progress` during streaming */
export interface AiJobProgressEvent {
    sessionId: string;
    type: string;                   // 'tool_call' | 'section_complete' | custom
    sectionKey?: string;            // e.g. 'Bilanz-Aktiva'
    toolName?: string;
    toolArgs?: Record<string, unknown>;
    toolCallCount?: number;
    remainingErrors?: number | null;
    /** Legacy English fallback string (kept for backward compat). */
    message?: string;
    /**
     * i18n key for the user-visible message. FE translates this via the
     * i18next pipe. Preferred over `message` when present.
     */
    messageKey?: string;
    /** Interpolation params for `messageKey` (e.g. `{ sectionKey, toolName }`). */
    messageParams?: Record<string, unknown>;
    [key: string]: unknown;         // extensible for future agents
}

/** Emitted via `ai:job:completed` when the job finishes */
export interface AiJobCompletedEvent {
    sessionId: string;
    status: 'COMPLETED' | 'COMPLETED_WITH_WARNINGS' | 'FAILED';
    /** Legacy English fallback string (kept for backward compat). */
    errorMessage?: string;
    /** i18n key for the failure reason — FE translates via the i18next pipe. */
    errorMessageKey?: string;
    /** Interpolation params for `errorMessageKey`. */
    errorMessageParams?: Record<string, unknown>;
}

/** Emitted via `ai:chat:message` for real-time chat streaming */
export interface AiChatMessageEvent {
    sessionId: string;
    role: 'user' | 'agent';
    content: string;
}
